module.exports = __webpack_public_path__ + "static/img/euFlag.2fc1101.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/euFlag.svg
// module id = sl3B
// module chunks = 55